import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito equipo especial?',
    a: 'No, solo tu cama y tu pijama.'
  }, {
    q: '¿Tengo que ser flexible?',
    a: 'No, el método está diseñado para hombres que hoy no pueden ni tocarse las puntas de los pies.'
  }, {
    q: '¿Cuánto tiempo tardaré en ver resultados?',
    a: 'La ligereza la sientes desde la primera mañana.'
  }, {
    q: '¿Es seguro si tengo sobrepeso?',
    a: 'Es el método más seguro, ya que lubricas las articulaciones sin cargarles peso encima.'
  }];
  return <section className="bg-stone-950 text-stone-50 py-24 px-4 border-t border-stone-800" data-id="element-14">
      <div className="max-w-3xl mx-auto" data-id="element-15">
        <FadeIn data-id="element-16">
          <h2 className="text-3xl md:text-4xl font-black mb-12 text-center text-stone-50" data-id="element-17">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-18">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-19" />)}
          </div>
        </FadeIn>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-stone-900 border border-stone-800 rounded-xl overflow-hidden" data-id="element-20">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-21">
        <span className="text-lg md:text-xl font-bold text-stone-200" data-id="element-22">
          {question}
        </span>
        <ChevronDown className={`w-6 h-6 text-amber-500 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-23" />
      </button>
      <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-24">
        <p className="text-stone-400 text-lg" data-id="element-25">{answer}</p>
      </div>
    </div>;
}